export const suppressResizeObserverErrors = (): void => {
  const OriginalResizeObserver = window.ResizeObserver;

  window.ResizeObserver = class extends OriginalResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      const wrappedCallback: ResizeObserverCallback = (...args) => {
        requestAnimationFrame(() => {
          try {
            callback(...args);
          } catch (error) {
            console.warn("ResizeObserver error suppressed:", error);
          }
        });
      };
      super(wrappedCallback);
    }
  };

  const originalError = console.error;
  console.error = (...args: unknown[]) => {
    const message = args.join(" ");
    if (
      message.includes("ResizeObserver") ||
      message.includes("loop completed") ||
      message.includes("loop limit exceeded")
    ) {
      return;
    }
    originalError.apply(console, args);
  };

  window.addEventListener(
    "error",
    (e) => {
      const message = e.message || e.error?.message || "";
      if (message.includes("ResizeObserver")) {
        e.stopImmediatePropagation();
        e.preventDefault();
        return false;
      }
    },
    { capture: true }
  );

  window.addEventListener("unhandledrejection", (e) => {
    const message = String(e.reason);
    if (message.includes("ResizeObserver")) {
      e.preventDefault();
    }
  });
};
